import React from "react";
import GameListSwitcherContainer from "../GamesMenu/GameListSwitcherContainer";
import GamesMenuContainer from "../GamesMenu/GamesMenuContainer";
import {FormattedMessage} from "react-intl";

class InitPage extends React.PureComponent {

    componentDidUpdate() {
        this.props.onLoad()
    }

    componentDidMount() {
        this.props.onLoad()
    }

    render() {
        let {
            initLoading
        } = this.props;
        return (
            <div className='rankings'>
                <GameListSwitcherContainer/>
                <div className="my-results">
                    <div className="my-results__col-left">
                        <GamesMenuContainer/>
                    </div>
                    <div className="my-results__col-middle">
                        {initLoading ?
                            <div className="alert alert-warning"><FormattedMessage id="app.initLoading"/></div>
                            :
                            <div className="alert alert-info">Nothing to display</div>
                        }
                    </div>
                </div>
            </div>
        );
    }
}


export default InitPage